import socket from '@/services/socket.js'

export default {
  /**
   * Get all requests for current user group.
   *
   * @param group_id
   * @returns Promise
   */
  getAllInGroup(group_id) {
    const action = '/request_access/get_by_group_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.request_access)
      })
    })
  },

  /**
   * Get all requests for specific child.
   *
   * @param user_id
   * @returns Promise
   */
  getAllForChild(user_id) {
    const action = '/request_access/get_by_user_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.request_access)
      })
    })
  },

  /**
   * Get child request by request id.
   *
   * @param id
   * @param user_id
   * @returns Promise
   */
  get(id, user_id) {
    const action = '/request_access/get'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        id,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data.request_access)
      })
    })
  },

   /**
   * Clear all requests.
   *
   * @param group_id
   * @returns Promise
   */
  clearAll(group_id) {
    const action = '/request_access/clear_by_group_id'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        group_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Ignore request.
   *
   * @param id
   * @param user_id
   * @returns Promise
   */
  ignore(id, user_id) {
    const action = '/request_access/deny'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        id,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  },

  /**
   * Grant request.
   *
   * @param id
   * @param user_id
   * @returns Promise
   */
  grant(id, user_id) {
    const action = '/request_access/grant'

    return new Promise((resolve, reject) => {
      socket.emit(action, {
        action,
        id,
        user_id
      }, (error, data) => {
        if (error) {
          reject(new Error(error))
        }

        resolve(data)
      })
    })
  }
}